import type { DigitalLectureVideoCard } from '~/models/digital-lecture'

export function useDigitalLectureRandom(excludeIds: Ref<number[]> | number[]) {
  const { $services } = useNuxtApp()

  const items = ref<DigitalLectureVideoCard[]>([])
  const loading = ref(false)

  async function load() {
    loading.value = true
    try {
      const ids = unref(excludeIds) ?? []
      items.value = await $services.digitalLectureService.detail.getRandom(ids)
    }
    catch (error) {
      console.warn('[useDigitalLectureRandom] Failed to fetch random videos:', error)
      items.value = []
    }
    finally {
      loading.value = false
    }
  }

  onMounted(load)

  return {
    items,
    loading,
    refresh: load,
  }
}
